import "./style.css";
import Swiper, { Pagination } from "swiper";

export default class Carousel {
  static selector = ".s-text-carousel";

  constructor(block) {
    this.block = block;
    this.$paginationItems = block.querySelectorAll(".s-pagination__item");
  }

  onChange(index) {
    this.swiper.slideTo(index);
  }

  onSlideChanged() {
    const { activeIndex } = this.swiper;
    this.$paginationItems.forEach(($el, index) => {
      const $number = $el.querySelector(".s-pagination__item-number");
      $number.classList.remove("h3");
      $number.classList.remove("h1");

      if (activeIndex === index) $number.classList.add("h1");
      else $number.classList.add("h3");
    });
  }

  initSwiper() {
    this.$pagination = this.block.querySelector(".s-pagination");
    this.$pagination.callback = this.onChange.bind(this);

    this.swiper = new Swiper(this.$root, {
      slidesPerView: 1,
    });

    this.swiper.on("slideChange", () => {
      this.onSlideChanged();
    });
  }

  onReady() {
    this.$root = this.block.querySelector(".swiper");
    this.initSwiper();
  }
}
